import { render, staticRenderFns } from "./CommunicationsView.vue?vue&type=template&id=74c41f74&"
import script from "./CommunicationsView.vue?vue&type=script&lang=ts&"
export * from "./CommunicationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports